/**
 * Created by xiaojielin on 17/1/9.
 */
function WxLogin (a, b) {
  var e
  var c = b.createElement('iframe')
  var d = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + a.appid + '&scope=' + a.scope + '&redirect_uri=' + a.redirect_uri + '&state=' + a.state + '&login_type=jssdk'
  d += a.style ? '&style=' + a.style : ''
  d += a.href ? '&href=' + a.href : ''
  c.src = d
  c.frameBorder = '0'
  c.allowTransparency = 'true'
  c.scrolling = 'no'
  c.width = '300px'
  c.height = '400px'
  e = b.getElementById(a.id)
  e.innerHTML = ''
  e.appendChild(c)
}

export default WxLogin



// WEBPACK FOOTER //
// ./src/service/wxLogin.js